import api from '~/api/client';
import { CONSUMER_API_PATH } from './config';
import { UserDataResponse } from '@/interfaces/user';
import { Response } from '@/interfaces/api';

export function getUserInfo(): Response<UserDataResponse> {
  return api.client.get(`${CONSUMER_API_PATH}/me/`);
}
